import { useState, useEffect } from "react";
import fetchAPI from "../fetchApi";

const useApi = (endpoint, options = {}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const fetchedData = await fetchAPI(endpoint, options);
        setData(fetchedData);
      } catch (err) {
        console.error(err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, []); // eslint-disable-line

  return { data, loading, error };
};

export default useApi;
